// extracted by mini-css-extract-plugin
export default {"wrapper":"Objects_wrapper__vtoLA","header":"Objects_header__2cpw9","search_wrapper":"Objects_search_wrapper__kstpQ"};